import { COUNT_DOWN_DATE_ACTION, GET_STATIC_MEMBER_LIST_ACTION, GET_WEBSITE_BLOG_LIST_ACTION } from "../../utils/constants"


const initialState = [];

function countDownDateReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case COUNT_DOWN_DATE_ACTION:
      return [...state, payload];
    case GET_WEBSITE_BLOG_LIST_ACTION:
      return [...state, payload];
    case GET_STATIC_MEMBER_LIST_ACTION:
      return [...state, payload];

    default:
      return state;
  }
};

export default countDownDateReducer;